module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("game " + (_vm.hover && !_vm.found && !_vm.expertMode ? 'hover' : '')),
    on: {
      "mousemove": _vm.onMouseMove,
      "touchmove": _vm.onMouseMove,
      "click": _vm.onClick
    }
  }, [(_vm.found) ? _c('find-animal', {
    attrs: {
      "animal": _vm.animal,
      "initialX": _vm.x,
      "initialY": _vm.y
    },
    on: {
      "complete": _vm.onAnimalComplete
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22b90c4f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 160
// module chunks = 2